﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVX = void 0;
const GUIController_1 = require("./appControllers/GUIController");
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateApp_1 = require("./states/abstracts/StateApp");
const StateLoading_1 = require("./states/StateLoading");
const DesignThemeEnum_1 = require("./enums/DesignThemeEnum");
const Web3Controller_1 = require("./appControllers/Web3Controller");
class AppVX {
    constructor() {
        AppVX.Inst = this;
        StateApp_1.StateUp.App = this;
        gs_1.StateGS.DefaultStateName = 'loading';
        this.gui = new GUIController_1.GUIController(this);
        this.chain = new Web3Controller_1.Web3Controller(this);
        this.gui.setTheme(DesignThemeEnum_1.DesignThemeEnum.LightGrey);
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
            yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            yield this.chain.start();
            if (this.chain.isConnected) {
                //  const byUrl = await StateGS.RunByUrl()
                //   if (byUrl === StateRunResultEnum.Failed) 
                yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
            }
            else {
                yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            }
        });
    }
    awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
}
exports.AppVX = AppVX;
AppVX.ADDRESS_VController = "0x16D360ae36851a3B4F6256c15b90C30Cf0fC6B54";
AppVX.ADDRESS_VXStrategyV1 = "0xa3466257aEe03495C057B94382EEc266B94C89cD";
AppVX.ADDRESS_VXSManagerV2 = "0xC6641d5B6Cb43045BC38F7c294f42215A0E4072C";
AppVX.ADDRESS_PulseXRouterV1 = "0x98bf93ebf5c380C0e6Ae8e192A7e2AE08edAcc02";
AppVX.ADDRESS_PulseXRouterV2 = "0x165C3410fC91EF562C50559f7d2289fEbed552d9";
AppVX.CHAIN_RPC = "https://rpc.pulsechain.com";
//public static CHAIN_RPC:string="https://rpc.v4.testnet.pulsechain.com"
AppVX.CHAIN_ID = 369;
AppVX.version = "1.0.0";
//# sourceMappingURL=AppVX.js.map